import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { Component } from 'react';

import { ProgramVisibility } from '../../api/programs.interface';
import { buildProgramSchedulePath } from './programs.utils';

interface Props {
    displayName?: string;
    name?: string;
    onCancel: () => void;
    onConfirm: () => void;
    processing: boolean;
    totalDays?: number;
    totalWeeks?: number;
    visibility?: ProgramVisibility;
    visible: boolean;
}

class ProcessProgramDialog extends Component<Props> {
    render() {
        const { displayName, name, onCancel, onConfirm, processing, totalDays, totalWeeks, visibility, visible } = this.props;

        return (
            <Dialog fullWidth maxWidth="xs" open={visible}>
                <DialogTitle>Process Program</DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ display: 'grid', gap: 1.25 }}>
                        <Typography variant="body2"><strong>Program:</strong> {displayName || name}</Typography>
                        <Typography variant="body2"><strong>Program key:</strong> {name}</Typography>
                        <Typography variant="body2"><strong>Schedule path:</strong> {name ? buildProgramSchedulePath(name) : 'Unavailable'}</Typography>
                        <Typography variant="body2"><strong>Weeks:</strong> {totalWeeks || 0}</Typography>
                        <Typography variant="body2"><strong>Configured day entries:</strong> {totalDays || 0}</Typography>
                        <Typography variant="body2"><strong>Visibility:</strong> {visibility || 'draft'}</Typography>
                        <Typography color="text.secondary" variant="body2">
                            This rebuilds the published workout schedule from the current program catalog metadata and editable program content.
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, py: 2 }}>
                    <Button disabled={processing} onClick={onCancel}>Cancel</Button>
                    <Button disabled={processing || !name} onClick={onConfirm} variant="contained">
                        {processing ? 'Processing...' : 'Process Program'}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default ProcessProgramDialog;